import config from 'config'
import React, { Fragment } from 'react'
import { connect, useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import history, { redirectToPage } from 'srcReact/helpers/history'
import { commonActions } from 'srcReact/components'
import { useEffect } from 'react'

const GreaterThanFreeSeats = (props) => {
  const { t, isBillable, totalSeatsAvailable, workplaceId, closeModal } = props
  const {
    common: { isNative }
  } = useSelector((state) => state)

  const handlePricingClick = () => {
    redirectToPage('/0/support', isNative)
  }

  const handleManageInvitesClick = () => {
    closeModal()
    // //nativeapp
    // if (isNative) {
    //   window.location = config.webUrl + `/0/workplace/manage-invites-page/${workplaceId}`
    //   return
    // }
    // history.push(`/0/workplace/manage-invites-page/${workplaceId}`)
  }

  return (
    <Fragment>
      <h2 className='popin-content--title'>{t('billing.popin.greaterThanFreeSeats.title')}</h2>
      <p className='popin-content--text'>
        {isBillable ? t('billing.popin.greaterThanFreeSeats.ownerText') : t('billing.popin.greaterThanFreeSeats.text')}
      </p>
      <div className='popin-content--image'>
        <img src={`${config.assetUrl}/images/build-onboarding.svg`} alt='build-onboarding' />
      </div>
      <div className='popin-content--controllers'>
        {totalSeatsAvailable > 0 && (
          <button type='button' className='button is-secondary' onClick={() => handleManageInvitesClick()}>
            {t('billing.popin.greaterThanFreeSeats.btnPrimary')}
          </button>
        )}
        {isBillable && (
          <button type='button' className='button is-primary' onClick={() => handlePricingClick()}>
            {t('global.contactUs')}
          </button>
        )}
      </div>
    </Fragment>
  )
}

const actionCreators = {
  closePopin: commonActions.closePopin
}

function mapStateToProps(state) {
  const { workplace } = state
  const { current_workplace } = workplace
  return { current_workplace }
}

const ExtendedComponent = withTranslation('common')(GreaterThanFreeSeats)
const connectedGreaterThanFreeSeats = connect(mapStateToProps, actionCreators)(ExtendedComponent)

export { connectedGreaterThanFreeSeats as GreaterThanFreeSeats }
